export class excelLiquidacionesRequest {
  idEmpresa: number;
  idUsuario: number;
  idLegajo: number;
  periodo: string;
  idSeccion: number;
  fileName: string;
}
